import React from "react";
import { Viewer3DSlider } from "components";

export const MinimizedControls: React.FunctionComponent = () => {
  return <Viewer3DSlider />;
};
